import clsx from "clsx";
import copy from "copy-to-clipboard";
import { useToasts } from "react-toast-notifications";

import { GenericTooltip } from "@components/tooltip-container";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { useLandingPageAnalyticsContext } from "@features/landing-page-analytics/hooks";

export const NameDataFormatter = ({
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { addToast } = useToasts();

  const {
    filters: { level },
  } = useLandingPageAnalyticsContext();

  const isAd = level === "ad";
  const isAdset = level === "adset";
  const isCampaign = level === "campaign";

  let sourceAndMedium = null;

  if (isCampaign) {
    try {
      const adKey = JSON.parse(row.adKey);
      sourceAndMedium = JSON.parse(adKey?.platform);
    } catch {
      // Do nothing
    }
  }

  return (
    <div className="flex items-center mx-3 h-full font-sans relative name-table-cell">
      <div className="hide-cell-actions absolute h-full right-0">
        <div className="h-full flex items-center space-x-2">
          <GenericTooltip
            content="Copy"
            noInfoCircle
            overlayClassName="pointer-events-none"
          >
            <i
              className={clsx(
                "bg-white elevation-1 rounded-full p-[5px] fa-sharp fa-solid fa-clone",
                "cursor-pointer text-md text-primary font-light",
              )}
              onClick={() => {
                addToast("COPIED NAME TO CLIPBOARD", { appearance: "success" });
                copy(row.name);
              }}
            ></i>
          </GenericTooltip>
        </div>
      </div>
      <div className="flex items-start flex-column w-full truncate">
        <span
          className={clsx("font-semibold text-xs text-left w-full truncate", {
            "leading-3": isAd,
          })}
        >
          {row.name}
        </span>
        {isCampaign && sourceAndMedium?.medium && (
          <span className="cell-subtitle font-normal w-full truncate leading-3">
            Medium: {sourceAndMedium.medium}
          </span>
        )}
        {isCampaign && sourceAndMedium?.source && (
          <span className="cell-subtitle font-normal w-full truncate leading-3">
            Source: {sourceAndMedium.source}
          </span>
        )}
        {isAd && (
          <span className="cell-subtitle font-normal w-full truncate leading-3">
            {row.adsetName}
          </span>
        )}
        {(isAdset || isAd) && (
          <span className="cell-subtitle font-normal w-full truncate leading-3">
            {row.campaignName}
          </span>
        )}
      </div>
    </div>
  );
};
